export default "__VITE_ASSET__B3dExx$c__"